import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { translate } from "react-i18next";

const SurveyInfoModal = props => {
	const { t } = props;
	return (
		<Modal open={props.open}>
			{/* <Modal.Header>Select a Photo</Modal.Header> */}
			<Modal.Content image style={{ flexDirection: "column" }}>
				<p>{t("surveyModalText1")}</p>
				<p>{t("surveyModalText2")}</p>
			</Modal.Content>
			<Modal.Actions className="flex-center">
				<Button positive onClick={props.onClose}>
					{t("startSurvey")}
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default translate()(SurveyInfoModal);



// WEBPACK FOOTER //
// ./src/features/modules/dynamic-survey/survey-info-modal/SurveyInfoModal.js